module.exports = __webpack_public_path__ + "static/img/all_game.4497fe36.png";